import { fmtChange } from "../lib/format";

interface Props {
  value: number | null;
}

export function ChangeBadge({ value }: Props) {
  if (value === null || !Number.isFinite(value)) {
    return <span className="text-slate-400">—</span>;
  }
  const positive = value > 0;
  const negative = value < 0;
  // Buyer's perspective: rising prices hurt the buyer (red), falling prices
  // help (green). Inverted vs. the conventional trader view.
  const cls = positive
    ? "bg-rose-500/15 text-rose-700 dark:text-rose-300 ring-rose-500/30"
    : negative
      ? "bg-emerald-500/15 text-emerald-700 dark:text-emerald-300 ring-emerald-500/30"
      : "bg-slate-500/10 text-slate-600 dark:text-slate-300 ring-slate-500/20";
  return (
    <span
      className={`inline-flex items-center rounded px-1 py-px text-[10px] font-medium ring-1 ring-inset ${cls} tabular-nums`}
    >
      {fmtChange(value)}
    </span>
  );
}
